import React from 'react';

const BusinessVerification = () => {
  return (
    <div style={{paddingTop: '100px'}}>
      <section className="section">
        <div className="container">
          <h1 className="section-title">Business Verification & Documentation</h1>
          
          <div style={{maxWidth: '800px', margin: '0 auto', lineHeight: '1.8'}}>
            <div style={{background: '#f0f9ff', padding: '2rem', borderRadius: '10px', marginBottom: '2rem', border: '2px solid #3b82f6'}}>
              <h2 style={{color: '#1e40af', marginBottom: '1rem'}}>Official Business Documentation</h2>
              <p style={{marginBottom: '0'}}>
                MEES HOLDINGS INC is a legitimate business entity registered in New York State. We provide 
                complete business verification documentation for A2P registration and carrier approval processes. 
                All information is verifiable through official government databases and public records.
              </p>
            </div>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Legal Business Entity</h2>
            <div style={{background: '#f8fafc', padding: '2rem', borderRadius: '10px', marginBottom: '2rem'}}>
              <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem'}}>
                <div>
                  <p><strong>Legal Business Name:</strong></p>
                  <p>MEES HOLDINGS INC</p>
                </div>
                <div>
                  <p><strong>Business Structure:</strong></p>
                  <p>Corporation (INC)</p>
                </div>
                <div>
                  <p><strong>EIN (Tax ID):</strong></p>
                  <p>93-4196857</p>
                </div>
                <div>
                  <p><strong>State of Incorporation:</strong></p>
                  <p>New York</p>
                </div>
                <div>
                  <p><strong>Business Registration:</strong></p>
                  <p>2020 (5 years operating)</p>
                </div>
                <div>
                  <p><strong>NAICS Code:</strong></p>
                  <p>541613 - Marketing Consulting</p>
                </div>
                <div>
                  <p><strong>Business Owner:</strong></p>
                  <p>Esther Buaki</p>
                </div>
              </div>
            </div>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Physical Business Address</h2>
            <div style={{background: '#f0fdf4', padding: '2rem', borderRadius: '10px', marginBottom: '2rem', border: '1px solid #16a34a'}}>
              <p><strong>Principal Business Address:</strong></p>
              <p>MEES HOLDINGS INC<br />
              2022 E 9TH ST<br />
              BROOKLYN, NY 11223<br />
              United States</p>
              
              <p style={{marginTop: '1rem'}}><strong>Address Verification:</strong></p>
              <p>✓ USPS Verified Address<br />
              ✓ Commercial Business Location<br />
              ✓ Registered with New York State</p>
            </div>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Business Contact Information</h2>
            <div style={{background: '#f8fafc', padding: '2rem', borderRadius: '10px', marginBottom: '2rem'}}>
              <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem'}}>
                <div>
                  <p><strong>Business Email:</strong></p>
                  <p>info@meesmarketing.com</p>
                </div>
                <div>
                  <p><strong>Support Email:</strong></p>
                  <p>support@meesmarketing.com</p>
                </div>
                <div>
                  <p><strong>Legal Email:</strong></p>
                  <p>legal@meesmarketing.com</p>
                </div>
                <div>
                  <p><strong>Privacy Email:</strong></p>
                  <p>privacy@meesmarketing.com</p>
                </div>
                <div>
                  <p><strong>Website:</strong></p>
                  <p>https://meesmarketing.com</p>
                </div>
                <div>
                  <p><strong>Business Hours:</strong></p>
                  <p>Mon-Fri 9AM-6PM EST</p>
                </div>
              </div>
            </div>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Industry Classification & Services</h2>
            <div style={{background: '#f0f9ff', padding: '2rem', borderRadius: '10px', marginBottom: '2rem', border: '1px solid #3b82f6'}}>
              <p><strong>Primary Business Activity:</strong> SMS Marketing Services Reseller</p>
              <p><strong>Industry Sector:</strong> Digital Marketing & Communications</p>
              <p><strong>Business Model:</strong> Authorized reseller partnering with established SMS service providers</p>
              <p><strong>Service Categories:</strong></p>
              <ul style={{paddingLeft: '2rem', marginTop: '0.5rem'}}>
                <li>Reselling Application-to-Person (A2P) SMS Services</li>
                <li>Marketing Campaign Management & Consulting</li>
                <li>TCPA & CAN-SPAM Compliance Guidance</li>
                <li>Customer Engagement Solutions</li>
                <li>Business Communication Consulting</li>
              </ul>
            </div>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Regulatory Compliance Status</h2>
            <div style={{background: '#f0fdf4', padding: '2rem', borderRadius: '10px', marginBottom: '2rem', border: '1px solid #16a34a'}}>
              <h3 style={{color: '#16a34a', marginBottom: '1rem'}}>Compliance Commitment</h3>
              <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem'}}>
                <div style={{textAlign: 'center', padding: '1rem', background: 'white', borderRadius: '8px'}}>
                  <p style={{fontWeight: '600', color: '#16a34a'}}>✓ TCPA Compliant</p>
                  <p style={{fontSize: '0.9rem'}}>Following all TCPA requirements</p>
                </div>
                <div style={{textAlign: 'center', padding: '1rem', background: 'white', borderRadius: '8px'}}>
                  <p style={{fontWeight: '600', color: '#16a34a'}}>✓ CAN-SPAM Adherent</p>
                  <p style={{fontSize: '0.9rem'}}>Anti-Spam Regulations</p>
                </div>
                <div style={{textAlign: 'center', padding: '1rem', background: 'white', borderRadius: '8px'}}>
                  <p style={{fontWeight: '600', color: '#2563eb'}}>⏳ A2P Registration</p>
                  <p style={{fontSize: '0.9rem'}}>Preparing for carrier registration</p>
                </div>
                <div style={{textAlign: 'center', padding: '1rem', background: 'white', borderRadius: '8px'}}>
                  <p style={{fontWeight: '600', color: '#16a34a'}}>✓ Trusted Partners</p>
                  <p style={{fontSize: '0.9rem'}}>Working with approved providers</p>
                </div>
              </div>
            </div>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Business Operations Verification</h2>
            <div style={{background: '#f8fafc', padding: '2rem', borderRadius: '10px', marginBottom: '2rem'}}>
              <p><strong>Operational Status:</strong> Active and Operating</p>
              <p><strong>Years in Business:</strong> 5 Years (Since 2020)</p>
              <p><strong>Business Model:</strong> Authorized SMS Services Reseller</p>
              <p><strong>Service Delivery:</strong> Through partnerships with tier-1 SMS providers</p>
              <p><strong>Geographic Coverage:</strong> United States</p>
              <p><strong>Target Market:</strong> Small to medium-sized businesses</p>
              <p><strong>Support Availability:</strong> Business hours with email support</p>
            </div>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Business Verification Resources</h2>
            <div style={{background: '#f8fafc', padding: '2rem', borderRadius: '10px', marginBottom: '2rem'}}>
              <p><strong>New York State Business Search:</strong></p>
              <p>Verify our business registration at: <a href="https://apps.dos.ny.gov/publicInquiry/" target="_blank" rel="noopener noreferrer" style={{color: '#2563eb'}}>NY Department of State - Entity Search</a></p>
              <p style={{marginTop: '1rem'}}><strong>IRS EIN Verification:</strong></p>
              <p>Our EIN (93-4196857) is registered with the Internal Revenue Service</p>
              <p style={{marginTop: '1rem'}}><strong>Physical Address Verification:</strong></p>
              <p>Our business address (2022 E 9TH ST, BROOKLYN, NY 11223) is USPS verified</p>
            </div>

            <div style={{background: '#fef2f2', padding: '2rem', borderRadius: '10px', border: '1px solid #ef4444'}}>
              <h3 style={{color: '#ef4444', marginBottom: '1rem'}}>Verification Notice</h3>
              <p style={{marginBottom: '0'}}>
                All business information provided is accurate and verifiable through official government databases. 
                MEES HOLDINGS INC maintains current business registration and tax compliance. We are preparing for 
                A2P registration with carriers and will complete this process upon account approval. Documentation 
                is available for verification by carriers and regulatory authorities upon request.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BusinessVerification;